import styled from "styled-components";

const ResponsiveCell = styled.div.attrs(props => ({
    width: (props.width ? props.width + " !important" : "100%"),
    break: props.break || "768px",
    align: (props.align ? props.align + " !important" : "left")
}))`
    box-sizing: border-box;
    -webkit-box-flex: 1;
    flex-grow: 1;
    width: ${props => props.width};
    padding: 0.1em;
    overflow: hidden;
    list-style: none;
    text-align: ${props => props.align};


    @media all and (max-width: ${props => props.break}) {
        background-color: #ccc;
        padding: 6px;
    }
`;

const ResponsiveFooter = styled(ResponsiveCell)`

`;

const ResponsiveTable = styled.div.attrs(props => ({
    cols: props.cols || 1,
    break: props.break || "768px"
}))`
    display: -webkit-box;
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 3em 0;
    padding: 0;

    & > ${ResponsiveCell} {
        width: ${props => (100 / props.cols) + "%"};
    }

    @media all and (max-width: ${props => props.break}) {
        display: block;
        > ${ResponsiveCell} { width: 100% !important; }
        > ${ResponsiveFooter} { margin-bottom: 1em; }
    }
`;

const ResponsiveHead = styled(ResponsiveCell)`
    
`;

export { ResponsiveTable, ResponsiveHead, ResponsiveCell, ResponsiveFooter };